<template>
	<section class="login p-fixed d-flex text-center bg-login">
        <div class="container">
             <div class="row">
                <div class="col-sm-12">
                    <!-- Authentication card start -->
                    <div class="login-card card-block auth-body mr-auto ml-auto">
                        <div class="alert" role="alert" v-show="status.status !== ''" v-bind:class="{'alert-danger': status.status == 'Error', 'alert-warning': status.status == 'Processing', 'alert-success': status.status == 'Success'}">
                            <strong>{{status.status}}</strong> {{status.message}}
                        </div>
                        <form role="form" class="md-float-material" v-on:submit.prevent="processLogin">
                            <!-- <div class="text-center">
                                <img src="assets/images/auth/logo-dark.png" alt="logo.png">
                            </div> -->
                            <div class="auth-box">
                                <div class="row m-b-20">
                                    <div class="col-md-12">
                                        <h3 class="text-left txt-primary">Sign In</h3>
                                    </div>
                                </div>
                                <hr/>
                                <div class="input-group">
                                    <select class="form-control" required="required" v-model="login.jlid">
                                        <option value="0">Please select job role</option>
                                        <option v-for="job in jobs" v-bind:value="job.id">{{ job.jobrole.name }}</option>
                                    </select>
                                </div>
                                <div class="input-group">
                                    <input type="email" name="email" v-model="login.emailaddress" class="form-control" placeholder="Your Email Address" v-bind:disabled="disable_inputs">
                                    <span class="md-line"></span>
                                </div>
                                <div class="input-group">
                                    <input type="password" name="password" v-model="login.password" class="form-control" placeholder="Password" v-bind:disabled="disable_inputs">
                                    <span class="md-line"></span>
                                </div>
                                <div class="row m-t-25 text-left">
                                    <div class="col-12">
                                        <div class="checkbox-fade fade-in-primary d-">
                                            <label>
                                                <input type="checkbox" value="">
                                                <span class="cr"><i class="cr-icon icofont icofont-ui-check txt-primary"></i></span>
                                                <span class="text-inverse">Remember me</span>
                                            </label>
                                        </div>
                                        <div class="forgot-phone text-right f-right">
                                            <a href="auth-reset-password.html" class="text-right f-w-600 text-inverse"> Forgot Password?</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="row m-t-30">
                                    <div class="col-md-12">
                                        <button class="btn btn-primary btn-md btn-block waves-effect text-center m-b-20">Sign in</button>
                                    </div>
                                </div>
                                <hr/>
                            </div>
                        </form>
                        <!-- end of form -->
                    </div>
                    <!-- Authentication card end -->
                </div>
                <!-- end of col-sm-12 -->
            </div>
        </div>
    </section>
</template>
<style scoped>
    .logo-holder{
        width: 130px !important;
    }
    .logo-holder img{
        width: 100% !important;
        margin: 0 auto;
    }
</style>
<script>

    //import {router} from '../router'

	export default{
		name: 'Login',
        data(){
            return{
                login:{
                    emailaddress: '',
                    password: '',
                    jlid: '0'
                },
                status: {
                    status: '',
                    message: ''
                },
                disable_inputs: false,
                jobs: []
            }
        },
        methods:{
            processLogin(){
                this.status.status = 'Processing'
                this.$store.dispatch('login', this.login)
                    .then((response)=>{
                        if(this.$store.getters.isLoggedIn){
                            var present_stage = this.$store.getters.user_data.data.present_stage
                            this.status.status = 'Success'
                            this.status.message = 'Login successful, redirecting...'
                            window.location.href = '/stage' + present_stage 
                        }
                        //console.log(response)
                    })
                    .catch((err)=>{
                        this.status.status = 'Error'
                        this.status.message = 'Invalid login details'

                        setTimeout(()=>{
                            this.status.status = ''
                        }, 3000)
                    })
            },

            logout: function(){
                this.$store.dispatch('logout')
            },

            getJobs: function(){
                var ii = {
                    what: 'GetJobs'
                }

                this.$socket.makeGetRequest(ii)
                    .then((response)=>{
                        if(response.type == 'GetJobs'){
                            this.jobs = response.data
                        }
                    })
                    .catch((e)=>{
                        console.log(e)
                    })
            }
        },

        mounted(){
            this.logout()

            this.getJobs()

            //console.log(this.$route.query.jlid)

            if(this.$route.query.jlid !== undefined){
                this.login.jlid = this.$route.query.jlid
            }
        }

	}
</script>